module.exports = __webpack_public_path__ + "static/platzi-93a87c8b05a1bf5d4a70aa8cc5873834.png";